import cookie from 'react-cookies'

export default function authHeader() {
    // const token = localStorage.getItem('token');
    const tokens = cookie.load('token')
      return {  
        
         Authorization: tokens 
    };
   
  }

export function twoFactorAuthHeader() {
    return {
        Authorization: cookie.load('ltoken')
    };
}
